import React from 'react';

import { Box, Grid, Typography, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';

//icon solution
import IconSolution1 from '../../../components/Icons/IconSolution/IconSolution1';
import IconSolution2 from '../../../components/Icons/IconSolution/IconSolution2';
import IconSolution3 from '../../../components/Icons/IconSolution/IconSolution3';
import IconSolution4 from '../../../components/Icons/IconSolution/IconSolution4';
import IconSolution5 from '../../../components/Icons/IconSolution/IconSolution5';
import IconSolution6 from '../../../components/Icons/IconSolution/IconSolution6';
import IconSolution7 from '../../../components/Icons/IconSolution/IconSolution7';
import IconSolution8 from '../../../components/Icons/IconSolution/IconSolution8';

import CarouselMobile from './carousel_mobile';

import StyledIGamingSolution from './styles';

import { useTranslation } from 'react-i18next';

const IGamingSolution = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const label1 = t('igamingsolu-title-desktop');
  const label1mobile = t('igamingsolu-title-mobile');
  const label2 = t('igamingsolu-desc-desktop');
  const iGamingSolutions = [
    {
      id: 1,
      title: t('igamingsolu-title-one'),
      content: t('igamingsolu-content-one'),
      image: <IconSolution1 />,
    },
    {
      id: 2,
      title: t('igamingsolu-title-two'),
      content: t('igamingsolu-content-two'),
      image: <IconSolution2 />,
    },
    {
      id: 3,
      title: t('igamingsolu-title-three'),
      content: t('igamingsolu-content-three'),
      image: <IconSolution3 />,
    },
    {
      id: 4,
      title: t('igamingsolu-title-four'),
      content: t('igamingsolu-content-four'),
      image: <IconSolution4 />,
    },
    {
      id: 5,
      title: t('igamingsolu-title-five'),
      content: t('igamingsolu-content-five'),
      image: <IconSolution5 />,
    },
    {
      id: 6,
      title: t('igamingsolu-title-six'),
      content: t('igamingsolu-content-six'),
      image: <IconSolution6 />,
    },
    {
      id: 7,
      title: t('igamingsolu-title-seven'),
      content: t('igamingsolu-content-seven'),
      image: <IconSolution7 />,
    },
    {
      id: 8,
      title: t('igamingsolu-title-eight'),
      content: t('igamingsolu-content-eight'),
      image: <IconSolution8 />,
    },
  ];

  return (
    <StyledIGamingSolution>
      <Box className="homeContent">
        <div
          // className="card"
          style={{
            padding: '1rem',
          }}
        >

          <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: '48px',
                fontWeight: '700',
                mb: 4,
                color: '#000000',
                lineHeight: '57.28px',
                [theme.breakpoints.down('lg')]: {
                  fontSize: '40px',
                  lineHeight: '47.73px',
                  display: 'none',
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                  },
                }}
              // viewport={{ once: true }}
              >
                {parse(label1)}
              </motion.div>
            </Typography>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: '48px',
                fontWeight: '700',
                mb: 4,
                color: '#000000',
                lineHeight: '59.5px',
                display: 'none',
                [theme.breakpoints.down('lg')]: {
                  fontSize: '40px',
                  lineHeight: '47.73px',
                  display: 'flex',
                  textAlign: 'center',
                  justifyContent: 'center',
                },
              }}
            >
              {parse(label1mobile)}
            </Typography>
            <Box sx={{
              padding: '0 30px', [theme.breakpoints.down('lg')]: {
                padding: '0 10px'
              }
            }}>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: '23.87px',
                  wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '600' : '700',
                  fontSize: '20px',
                  color: '#000000',
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '18px',
                    lineHeight: '23.4px',
                    fontWeight: 600,
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: 0.8,
                    },
                  }}
                  // viewport={{ once: true }}
                  className='label2'
                >
                  {parse(label2)}
                </motion.div>
              </Typography>
            </Box>
            <Box
              mt={5}
              mb={10}
              // px={12}
              display={'flex'}
              justifyContent={'center'}
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                color: '#000000',
                [theme.breakpoints.down('lg')]: {
                  mb: 0,
                },
              }}
            >
              {isMobile ? (
                <CarouselMobile />
              ) : (
                <Grid container spacing={2}>
                  {iGamingSolutions.map((item, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      key={index}
                      sx={{
                        justifyItems: 'center',
                      }}
                    >
                      <Box sx={{ maxWidth: '100%', maxHeight: '100%', mt: 5 }} display={'flex'} key={item.id}>
                        <Box
                          sx={{
                            backgroundColor: '#ffffff',
                            textAlign: 'center',
                            // paddingLeft: 0,
                            // paddingRight: 0,
                            // width: '628px',
                            // height: '321.56px',
                            maxWidth: '628px',
                            maxHeight: '100%',
                          }}
                        >
                          <Box
                            px={12}
                            sx={{
                              [theme.breakpoints.down('lg')]: {
                                width: '115px',
                                height: '114.88px',
                                // display: 'flex',
                                justifyContent: 'center',
                                textAlign: 'center',
                                justifySelf: 'center',
                              },
                            }}
                          >
                            {item.image}
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            sx={{
                              px: 8,
                              [theme.breakpoints.down('lg')]: {
                                px: 1,
                              },
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                mt: 2,
                                mb: 2,
                                lineHeight: '25.42px',
                                wordWrap: 'break-word',
                                fontWeight: 800,
                                fontSize: '21.3px',
                                color: '#000000',
                                [theme.breakpoints.down('lg')]: {
                                  mt: 1,
                                  fontSize: '30px',
                                  lineHeight: '35.8px',
                                  color: '#000',
                                },
                              }}
                            >
                              {item.title}
                            </Typography>
                          </Box>
                          <Box px={1}>
                            <Typography
                              variant="body1"
                              sx={{
                                // mb: 4,
                                // wordWrap: 'break-word',
                                fontWeight: 600,
                                fontSize: '16px',
                                color: '#000000',
                                lineHeight: '19.09px',
                                [theme.breakpoints.down('lg')]: {
                                  fontSize: '18px',
                                  lineHeight: '19.09px',
                                  color: '#000',
                                },
                              }}
                            >
                              {parse(item.content)}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          </Box>
        </div>
      </Box>
    </StyledIGamingSolution>
  );
};

export default IGamingSolution;
